/**
 * @fileoverview The class string the photo screens' small fields share.
 *
 * Kept in a file of their own rather than in a component, because the date and
 * the plant fields each live in their own file and would otherwise each carry a
 * copy that drifts. (The buttons laid over a picture are the shared PhotoButton,
 * ui/PhotoButton.)
 *
 * Where: DateTakenField and MoveToPlantField.
 * API: none.
 * Settings: none.
 * Words (en/es): none.
 *
 * @module photoField
 */

/**
 * The look of a small field on the photo screens: its name in small type
 * inside it, the answer under that, tapped to change.
 */
export const PHOTO_FIELD = 'flex min-h-[3.25rem] w-full min-w-0 flex-col justify-center rounded-md border bg-background px-3 py-1.5 text-left hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50';
